import axios from "axios";
import { loginRequest } from "../@types/Login";

const endpoint_user = "user";

const API_URL_USER = (process.env.REACT_APP_API_URL as string) + endpoint_user;

export class UserService {
  // Método para verificar usuarios
  static async verifyUser(token: string) {
    try {
      const response = await axios.get(`${API_URL_USER}/validate`, {
        params: { token },
      });
      return {
        status: response.status,
        message: response.data.message,
      };
    } catch (error: any) {
      return {
        status: error.response?.status || 500,
        message: error.response?.data?.message || "Error al validar el usuario",
      };
    }
  }

  // Método para registrar nuevos usuarios
  static async registerUser(data: loginRequest) {
    const response = await fetch(API_URL_USER, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    });

    if (response.status !== 201) {
      const errorData = await response.json();
      throw new Error(errorData.message || "Error al registrar usuario");
    }

    return { message: "Usuario registrado exitosamente" };
  }

  // Método para registrar nuevos usuarios
  static async updateUser(data: loginRequest) {
    const response = await fetch(API_URL_USER, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    });

    if (response.status !== 201) {
      const errorData = await response.json();
      throw new Error(errorData.message || "Error al registrar usuario");
    }

    return { message: "Usuario registrado exitosamente" };
  }


  // Método para obtener usuarios
  static async getUser(mail: string): Promise<any[]> {
    try {
      const response = await axios.get(`${API_URL_USER}`, { params: { mail } }); // Devuelve los datos en un array
      return [response.data];
    } catch (error: any) {
      console.error("Error al obtener el usuario:", error);
      return [];
    }
  }

  static async sendPasswordReset(email: string): Promise<void> {

    try {
        const response = await axios.delete(`${API_URL_USER}`+'/password', { params: { email } });
      } catch (error: any) {
        console.error("Error al obtener el usuario:", error);
      }
    
  }

  static async validateToken(token: string): Promise<string> {


      await axios.post(`${API_URL_USER}`+'/token/validate',{token: token})
      .then((response) => {
        return response.data;

      }).catch((err)=>{

        throw Error(err.message);
      })
    
      return "ok";

  }

  static async updatePasswordWithToken(token: string, newPassword: string): Promise<void> {
    await axios.put(`${API_URL_USER}`+'/password',{token: token, password: newPassword})
    .then((response) => {
      return response.data;

    }).catch((err)=>{

      throw Error(err.message);
    })

  }
    
}
